import React from "react";
import Lottie from "lottie-react";
import LoadingAnimation from "../../assets/images/gif/sdap-loading.json";
import "./LogoutLoading.scss";

interface LogoutLoadingProps {
  isLoggingOut: boolean;
}

/**
 * Shows a full-screen loading overlay while logout API is in progress.
 * Prevents user interaction and displays a loading indicator.
 * Only renders when isLoggingOut is true.
 */
export const LogoutLoading: React.FC<LogoutLoadingProps> = ({ isLoggingOut }) => {
  if (!isLoggingOut) {
    return null;
  }

  return (
    <div className="logout-loading-screen">
      <Lottie
        className="logout-loading-screen__spinner"
        animationData={LoadingAnimation}
        loop={true}
        style={{ width: 60, height: 60 }}
      />
    </div>
  );
};
